<template>
	<div class="syscheck-container">
		<div class="vr-candash-tabs-newcard vr-record">
			<div class="height">
				<div>
					<div class="prevres">
						<div
							class="candash-bold-black-txt-7 mb-3 d-flex align-items-center"
						>
							<img
								id="hideinmobile"
								@click="$bvModal.show('discardChange-vr')"
								class="mr-2 pointer"
								src="../../../../assets/newdesign/videoresume/blueBackTick.svg"
								alt=""
							/>
							<span v-if="!videoSaved">Create a Video Snapshot</span>
							<span v-if="videoSaved">Save your Video Snapshot</span>
							<img
								id="hideinlaptop"
								@click="$bvModal.show('discardChange-vr')"
								class="grey-cross"
								src="@/assets/newbuilder/grey-cross.svg"
								alt=""
							/>
						</div>
						<div
							v-if="candidateInfoState.profileName"
							class="mb-3 fs-14 fw-LM d-flex ml-2 align-items-center mob-justify-center-2"
						>
							<img
								src="../../../../assets/newdesign/dashboard/svg-resume.svg"
								alt=""
							/>
							{{ candidateInfoState.profileName }}
							<div class="hor-line"></div>
						</div>
						<div v-if="!videoSaved && !record" class="mt-2 ml-3 rec-title-3">
							Click the record button once you are ready to speak for at least
							one minute.
						</div>
						<div v-if="!videoSaved && record" class="mt-2 ml-3 rec-title-3">
							The recording will be stopped once the timer is over or you can
							use stop button.
						</div>
					</div>
					<div v-if="!videoSaved" class="candash-boldtxt ml-3 mt-2">
						{{ timerRemaining }}
					</div>
				</div>
				<div
					class="d-flex justify-content-between vr-flex-4 ml-3"
					:class="!videoSaved ? 'mob-vr-h1' : 'mob-vr-h2'"
				>
					<div class="w65">
						<div v-if="!videoSaved" class="candash-player">
							<b-progress
								:value="progressValue"
								:variant="progressVariant"
							></b-progress>
						</div>
						<div
							class="sp-black w-100 mt-2 position-relative d-flex align-items-center justify-content-center"
						>
							<div
								v-if="videoSaved || timeLeftInSeconds === 0"
								class="h-100 position-relative"
								:class="videoLoaded ? 'lapw75' : 'w-100'"
							>
								<video
									:class="{ 'flipped-video': true }"
									:kind="'video'"
									:isMuted="false"
									:autoplay="false"
									:loop="false"
									ref="playbackVideo"
									id="videoElement"
									style="object-fit: unset; height: 100%; border-radius: 5px"
									playsinline
									disablePictureInPicture
									disableRemotePlayback
									x-webkit-airplay="deny"
									class="width-unset"
									x5-playsinline
									webkit-playsinline
									@click="togglePlayPause"
									@loadedmetadata="onVideoLoaded"
									@timeupdate="updateProgress"
									@ended="onVideoEnded"
								></video>
								<div class="custom-controls" v-if="videoLoaded">
									<div
										class="controls-bottom justify-content-between align-items-center"
									>
										<div class="d-flex align-items-center mb-2">
											<button
												class="control-btn play-btn"
												@click="togglePlayPause"
											>
												<svg
													v-if="isPlaying"
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="white"
												>
													<path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
												</svg>
												<svg
													v-else
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="white"
												>
													<path d="M8 5v14l11-7z" />
												</svg>
											</button>
											<div class="mb-1">
												<span class="time-display"
													>{{ currentTimeFormatted }} /</span
												>
												<span class="time-display">
													{{ durationFormatted }}</span
												>
											</div>
										</div>

										<button class="control-btn volume-btn" @click="toggleMute">
											<svg
												v-if="isMuted"
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="white"
											>
												<path
													d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
												/>
											</svg>
											<svg
												v-else
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="white"
											>
												<path
													d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"
												/>
											</svg>
										</button>
									</div>
									<div class="time-progress-container">
										<div class="recorded-progress-bar" @click="seek">
											<div
												class="recorded-progress-filled"
												:style="{ width: progressPercent + '%' }"
											></div>
											<div
												class="recorded-progress-handle"
												:style="{ left: progressPercent + '%' }"
											></div>
										</div>
									</div>
								</div>
							</div>
							<div v-else class="h-100 w-100 position-relative">
								<div v-if="!videoSaved && isSubmitted" class="mob-vid-loader">
									<b-spinner variant="light"></b-spinner>
								</div>
								<video
									style="object-fit: unset; height: 100%; border-radius: 5px"
									:class="{ 'flipped-video': isSafari }"
									ref="recordingVideo"
									class="w-100"
									autoplay
									allowfullscreen="false"
									playsinline
								></video>
							</div>
							<div
								v-if="showProgressBar && progressPercentage < 100"
								class="vrs-comunicatn-tst-timer"
							>
								<div
									style="height: 85.7%"
									class="position-relative heigh p-3 d-flex flex-column justify-content-around align-content-center"
								>
									<div
										style="z-index: 1"
										class="d-flex justify-content-center align-items-center"
									>
										<div
											class="vrs-typingtest-progress-container"
											ref="progressContainer"
										>
											<div class="vrs-typingtest-valueprogress">
												<div class="vrs-time-txt">
													{{ progressPercentage }}%
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-center mt-2">
							<div class="position-relative">
								<div
									v-if="
									record &&
									!videoSaved &&
									timeLeftInSeconds > 60 &&
									showTooltip
									"
									:class="
										timeLeftInSeconds > 60
									? 'vrs-tooltip-disable'
									: 'vrs-tooltip'
									"
									style="z-index: 1"
								>
									The video can only be stopped after <br />
									you have spoken for a minute
								</div>
								<b-button
									v-if="!record && !videoSaved"
									@click="startStream()"
									class="candash-cancelBtn-2"
								>
									<img
										class="mr-2"
										src="../../../../assets/newdesign/dashboard/blueRadio.svg"
										alt=""
									/>
									Record</b-button
								>
								<div
									v-else-if="record && !videoSaved"
									@mouseover="showTooltip = true"
									@mouseleave="showTooltip = false"
								>
									<b-button
										:disabled="timeLeftInSeconds > 59"
										@click="stopRec()"
										class="candash-cancelBtn-2"
									>
										<img
											class="mr-2"
											src="../../../../assets/newdesign/dashboard/stopSquare.svg"
											alt=""
										/>
										Stop</b-button
									>
								</div>
								<b-button
									:disabled="showProgressBar"
									v-if="videoSaved"
									class="candash-cancelBtn-2"
									@click="retakeRec()"
									><img
										class="mr-2"
										src="../../../../assets/newdesign/videoresume/retakeCam.svg"
										alt=""
									/>Retake</b-button
								>
							</div>
						</div>
					</div>
					<div v-if="!uploaded" class="ml-2 sp-questions">
						<div class="spwhiteCard italic-head mt-0">
							Feel free to use the following pointers for your video snapshot
						</div>
						<div v-if="shimmer">
							<div
								v-for="(i, index) in loopvar"
								:key="index"
								class="spwhiteCard"
							>
								<img
									class="mr-2"
									src="../../../../assets/newdesign/dashboard/greyBlack.svg"
									alt=""
								/>
								<b-skeleton class="w-100 h-15"></b-skeleton>
							</div>
						</div>
						<div v-else>
							<div
								v-for="(question, index) in questions"
								:key="index"
								class="spwhiteCard"
							>
								<img
									class="mr-2"
									src="../../../../assets/newdesign/dashboard/greyBlack.svg"
									alt=""
								/>
								{{ question }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="!uploaded"
				id="hideinmobile"
				class="d-flex align-items-center justify-content-end"
			>
				<b-button v-b-modal.discardChange-vr class="candash-cancelBtn mr-4"
					>Cancel</b-button
				><b-button
					:disabled="!videoSaved || showProgressBar"
					@click="saveVideo"
					class="candash-addBtn"
					>Save</b-button
				>
			</div>
			<div
				v-if="!uploaded"
				class="d-flex align-items-center gap-3 vr-footer"
				id="hideinlaptop"
			>
				<div
					v-b-modal.discardChange-vr
					class="mob-cancelBtn position-relative w-50"
				>
					<b-button class="w-100">Cancel</b-button>
				</div>

				<div class="mob-addBtn w-50">
					<b-button
						:disabled="!videoSaved || showProgressBar"
						@click="saveVideo"
						class="w-100"
						>Save</b-button
					>
				</div>
			</div>
		</div>
		<HelpSection />
		<b-modal id="discardChange-vr" size="md" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div
						class="candash-modal-top justify-content-start no-border-bottom p-3"
					>
						<div class="width-10">
							<img
								class=""
								src="../../../../assets/New Profile/warning-icon-small.svg"
								alt=""
							/>
						</div>
						<div class="w-100">
							<div class="d-flex align-items-center justify-content-between">
								<div class="candash-modal-head">Discard Changes</div>
								<div
									class="d-flex justify-content-end pointer"
									@click="$bvModal.hide('discardChange-vr')"
								>
									<img
										class="rotate-on-hover"
										src="../../../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2 pr-3">
								Are you sure you want to
								{{ videoSaved ? "discard" : "stop creating" }} your video
								snapshot?
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-cancelBtn mr-4"
							@click="$bvModal.hide('discardChange-vr')"
							>Cancel</b-button
						>
						<b-button @click="bcktosyscheck()" class="candash-customBtn-vr"
							>Confirm</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<CvsInternet />
	</div>
</template>
<script>
import errorModal from "../../../../components/mixin/toast";
import Media from "@dongido/vue-viaudio";
import { mapGetters } from "vuex";
import CvsInternet from "@/components/Cvs/CvsInternet.vue";
import HelpSection from "../../../../views/Dashboard/components/HelpSection.vue";
import path from "path";
import {
	getQuestionsForVideoResume,
	getCandInfo,
	getTempPath,
	postVideoResume,
	initiateCvsUpload,
	uploadChunk,
	finishUpload,
} from "../../../../utils/apiFunctions";
export default {
	name: "videoResume",
	components: {
		HelpSection,
		Media,
		CvsInternet,
	},
	mixins: [errorModal],
	data() {
		return {
			fileData: null,
			showTooltip: false,
			shimmer: true,
			loopvar: 4,
			stream: undefined,
			recorder: null,
			timer: null,
			progressInterval: null,
			timerRemaining: "02:00",
			timeLeftInSeconds: 120,
			totalTimeInSeconds: 120,
			timeInSeconds: 0,
			time: 0,
			progressTime: 0,
			progress: 0,
			record: false,
			showProgressBar: false,
			progressPercentage: 0,
			videoSaved: false,
			uploaded: false,
			filePath: "",
			tempPath: {},
			questions: [],
			email: "",
			timestamp: null,
			videoStream: null,
			partNumber: 1,
			currentUpload: null,
			bucket: "cvrecruitmentmedia",
			bucketPath: null,
			uploadData: null,
			chunkBuffer: [],
			chunkBufferSize: 0,
			minChunkSize: 5 * 1024 * 1024,
			isSubmitted: false,
			resolveFlush: null,
			videoLoaded: false,
			currentTime: 0,
			duration: 0,
			isPlaying: false,
			isMuted: false,
			actualRecordedDuration: 0,
			capturedMimeType: "",
		};
	},
	mounted() {
		this.setupFullscreenListener();
		window.addEventListener("beforeunload", this.stopVideoStream);
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.stopVideoStream);
		this.stopVideoStream();
	},
	created() {
		this.getQuestionsAndCandInfo();
		this.askCameraPermission();
		// this.startStream();
	},

	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfoState: "getcandidateInfo",
			previewState: "getPreviewResume",
		}),
		progressValue() {
			return (this.timeLeftInSeconds / this.totalTimeInSeconds) * 100;
		},
		progressVariant() {
			if (this.timeLeftInSeconds <= 44) {
				return "danger"; // Red color
			} else if (this.timeLeftInSeconds <= 69) {
				return "warning"; // Yellow color
			} else {
				return "success"; // Green color
			}
		},
		progressPercent() {
			if (this.duration === 0) return 0;
			return (this.currentTime / this.duration) * 100;
		},
		currentTimeFormatted() {
			console.log(this.currentTime, "currentTime");
			return this.formatTime(this.currentTime);
		},
		durationFormatted() {
			console.log(this.duration, "duration");
			return this.formatTime(this.duration);
		},
	},
	methods: {
		formatTime(seconds) {
			if (isNaN(seconds) || !isFinite(seconds)) return "0:00";
			const mins = Math.floor(seconds / 60);
			const secs = Math.floor(seconds % 60);
			return `${mins}:${secs.toString().padStart(2, "0")}`;
		},
		onVideoLoaded() {
			const video = this.$refs.playbackVideo;
			console.log(video, video.duration);
			if (video) {
				if (video.duration === Infinity || isNaN(video.duration)) {
					this.duration = this.actualRecordedDuration;
				} else {
					this.duration = video.duration;
				}
				this.videoLoaded = true;
			}
		},
		togglePlayPause() {
			const video = this.$refs.playbackVideo;
			if (video) {
				if (video.paused) {
					video.play();
					this.isPlaying = true;
				} else {
					video.pause();
					this.isPlaying = false;
				}
			}
		},
		toggleMute() {
			const video = this.$refs.playbackVideo;
			if (video) {
				video.muted = !video.muted;
				this.isMuted = video.muted;
			}
		},
		updateProgress() {
			const video = this.$refs.playbackVideo;
			if (video) {
				this.currentTime = video.currentTime;
			}
		},
		seek(event) {
			const video = this.$refs.playbackVideo;
			const progressBar = event.currentTarget;
			const rect = progressBar.getBoundingClientRect();
			const pos = (event.clientX - rect.left) / rect.width;
			if (video) {
				video.currentTime = pos * this.duration;
			}
		},
		onVideoEnded() {
			this.isPlaying = false;
		},
		isSafari() {
			const userAgent = navigator.userAgent.toLowerCase();
			return (
				userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1
			);
		},
		setupFullscreenListener() {
			document.addEventListener("fullscreenchange", this.exitFullscreenIfVideo);
			document.addEventListener("fullscreenchange", this.exitFullscreenIfVideo);
			document.addEventListener(
				"webkitfullscreenchange",
				this.exitFullscreenIfVideo
			);
			document.addEventListener(
				"mozfullscreenchange",
				this.exitFullscreenIfVideo
			);
			document.addEventListener(
				"MSFullscreenChange",
				this.exitFullscreenIfVideo
			);
		},
		exitFullscreenIfVideo(event) {
			if (
				document.fullscreenElement &&
				event.target === document.getElementById("videoElement")
			) {
				document.exitFullscreen();
			}
		},
		async askCameraPermission() {
			try {
				this.videoStream = await navigator.mediaDevices.getUserMedia({
					video: true,
					audio: true,
				});
				window.localVideoStream = this.videoStream;
				this.$refs.recordingVideo.srcObject = this.videoStream;
				//till user clicks on reord the sound should be muted
				this.$refs.recordingVideo.muted = true;
			} catch (err) {
				this.loader = false;
			}
		},

		async startStream() {
			this.record = true;
			const video = this.$refs["recordingVideo"]; // Get the video element using Vue's 'this.$refs'
			video.muted = true; // Mute the video to avoid audio feedback during recording
			video.volume = 0;
			video.srcObject = this.videoStream;
			this.videoRecorder = new MediaRecorder(this.videoStream);
			this.startTimer();
			try {
				let mimeType = null;
				this.partNumber = 1;
				let firstBlob = true;
				let isCheck = false;

				this.currentUpload = {
					controller: null,
					promise: null,
					timeoutId: null,
				};
				let cancelCount = 0;
				const chunks = [];
				this.videoRecorder.ondataavailable = async (event) => {
					chunks.push(event.data);
					if (firstBlob) {
						const isCorrupted = await this.isBlobCorrupted(event.data);
						if (isCorrupted) {
							console.log("Blob is corrupted");
							location.reload();
							return;
						}
					}
					firstBlob = false;

					console.log("the event", event);
					if (!mimeType) {
						this.capturedMimeType = event.data.type;
						mimeType = this.parseMimeType(event.data.type);
						const res = await getTempPath(this.candidateInfoState._id);
						this.timestamp = Date.now();
						var fileName = `${this.candidateInfoState._id}_videoResume${this.timestamp}${mimeType}`;
						this.bucketPath = `CandidateInfo/dev/${this.candidateInfoState.email}/${this.candidateInfoState._id}/videoResume/${this.timestamp}/${fileName}`;
						const response = await initiateCvsUpload({
							bucket: this.bucket,
							fileName,
							bucketPath: this.bucketPath,
						});
						this.uploadData = response.data.data;
						console.log("the upload data", this.uploadData);
						localStorage.setItem("fileID", this.uploadData._id);
					}
					const arrayBuffer = await event.data.arrayBuffer();
					this.chunkBuffer.push(arrayBuffer);
					this.chunkBufferSize += arrayBuffer.byteLength;

					console.log(
						"buffer size:",
						(this.chunkBufferSize / (1024 * 1024)).toFixed(2),
						"MB",
						"| current chunk size:",
						(event.data.size / (1024 * 1024)).toFixed(2),
						"MB"
					);

					if (this.chunkBufferSize >= this.minChunkSize || this.isSubmitted) {
						if (isCheck) return;
						if (this.isSubmitted) isCheck = true;
						const combined = this.concatBuffers(this.chunkBuffer);
						this.chunkBuffer = [];
						this.chunkBufferSize = 0;
						// Wait for previous upload to complete or fail
						while (
							this.currentUpload?.promise &&
							(await this.isPromisePending(this.currentUpload.promise))
						) {
							console.warn(
								"Previous upload still pending, waiting up to 30s before aborting..."
							);

							const result = await Promise.race([
								this.currentUpload.promise.then(() => "completed"),
								new Promise((resolve) => {
									this.currentUpload.timeoutId = setTimeout(() => {
										// Only abort if it's still running
										this.currentUpload.controller?.abort();
										cancelCount++;
										resolve("aborted");
									}, 30000);
								}),
							]);

							console.log(`Previous upload ${result}`);
							clearTimeout(this.currentUpload.timeoutId);
							this.currentUpload.timeoutId = null;
						}

						if (cancelCount > 0) {
							this.stopTimer();
							this.videoRecorder?.stop();
							if (this.$refs.recordingVideo) {
								this.$refs.recordingVideo.srcObject = null;
							}
							const event = new CustomEvent("trigger-internet-disconnected", {
								detail: { isResumeVideo: true },
							});
							window.dispatchEvent(event);
							return;
						}

						// Capture state AFTER waiting
						const currentPartNumber = this.partNumber;
						const controller = new AbortController();
						this.currentUpload.controller = controller;

						try {
							const formData = new FormData();
							formData.append(
								"chunk",
								new Blob([combined], { type: this.capturedMimeType || mimeType }),
								"chunk.bin"
							);
							formData.append("fileID", this.uploadData._id);
							formData.append("partNumber", currentPartNumber);
							formData.append("uploadID", this.uploadData.uploadId);
							formData.append("bucket", this.bucket);
							formData.append("bucketPath", this.bucketPath);
							console.log("the form data", formData);

							const uploadPromise = uploadChunk(formData, controller.signal);
							this.currentUpload.promise = uploadPromise;

							const response = await uploadPromise;
							this.partNumber++;
							cancelCount = 0;
							console.log("Chunk upload response:", response);
							console.log(
								"Chunk stored successfully. Part number:",
								currentPartNumber
							);

							if (this.resolveFlush) {
								this.resolveFlush();
								this.resolveFlush = null;
							}
						} catch (error) {
							console.error("Error storing recorded chunk: ", error);
							if (
								error.name === "CanceledError" ||
								error.name === "AbortError"
							) {
								console.warn("Upload chunk API call aborted after 5 seconds");
							} else {
								this.currentUpload.promise = null;
								console.error("Error storing recorded chunk: ", error);
							}
						} finally {
							clearTimeout(this.currentUpload.timeoutId);
							this.currentUpload.timeoutId = null;
						}
					}
				};

				this.videoRecorder.onstop = async () => {
					let videoBlob = new Blob(chunks, {
						type: this.getSupportedMimeType(),
					});
					let videoURL = URL.createObjectURL(videoBlob);
					console.log(videoURL, "videiURL");

					// Set for playback
					const video = this.$refs.playbackVideo;
					if (video) {
						video.srcObject = null;
						video.src = videoURL;
						video.muted = true;
						video.load();
					}
				};
				this.videoRecorder.start(5000);
			} catch (e) {
				console.log("some error" + e);
			}
		},
		async flushFinalChunk() {
			console.log("Pushing final chunk");
			return new Promise(async (resolve) => {
				this.resolveFlush = resolve;

				const TIMEOUT = 30000;
				const checkInterval = 500;
				const start = Date.now();

				const waitForUpload = async () => {
					while (true) {
						const isPending = await this.isPromisePending(
							this.currentUpload?.promise
						);
						const elapsed = Date.now() - start;

						if (!isPending || elapsed > TIMEOUT) {
							console.log(
								`Upload completed in ${elapsed} ms. isPending: ${isPending}`
							);
							break;
						}

						await new Promise((r) => setTimeout(r, checkInterval));
					}

					this.videoRecorder?.stop();
				};

				await waitForUpload();
			});
		},
		isPromisePending(promise) {
			if (!promise) return false;
			const unique = {};
			return Promise.race([promise, Promise.resolve(unique)]).then(
				(value) => value === unique
			);
		},
		concatBuffers(buffers) {
			let totalLength = buffers.reduce((sum, b) => sum + b.byteLength, 0);
			let temp = new Uint8Array(totalLength);
			let offset = 0;
			for (let b of buffers) {
				temp.set(new Uint8Array(b), offset);
				offset += b.byteLength;
			}
			return temp.buffer;
		},
		parseMimeType(mimeString) {
			const mimeToExtension = {
				"video/webm": ".webm",
				"video/mp4": ".mp4",
				"video/x-matroska": ".mkv",
			};
			const [typePart] = mimeString.split(";");
			return mimeToExtension[typePart.trim()] || null;
		},
		isBlobCorrupted(blob) {
			return new Promise((resolve) => {
				const reader = new FileReader();

				reader.onload = () => {
					const buffer = new Uint8Array(reader.result);

					// Known file signature headers (magic numbers)
					const signatures = [
						{ magic: [0x66, 0x74, 0x79, 0x70] }, // ftyp for MP4
						{ magic: [0x52, 0x49, 0x46, 0x46] }, // RIFF for AVI
						{ magic: [0x4f, 0x67, 0x67, 0x53] }, // OggS
						{ magic: [0x1a, 0x45, 0xdf, 0xa3] }, // WebM/MKV
						{ magic: [0x00, 0x00, 0x01, 0xba] }, // MPEG
					];

					const found = signatures.some(({ magic }) => {
						return (
							buffer.findIndex((_, i) =>
								magic.every((byte, j) => buffer[i + j] === byte)
							) !== -1
						);
					});

					resolve(!found);
				};

				reader.onerror = () => {
					resolve(true); // If reading fails, assume corrupted
				};

				reader.readAsArrayBuffer(blob.slice(0, 2048)); // Read more for safety
			});
		},
		async getQuestionsAndCandInfo() {
			// Here we have tried to fetch the Questions and user data through API functions
			try {
				const res = await getQuestionsForVideoResume();
				const res1 = await getCandInfo();
				if (res.status === 200) {
					this.questions = res.data.data;
					this.shimmer = false;
				}
				if (res1.status === 200) {
					this.email = res1.data.data.email;
				}
			} catch (error) {
				return error;
			}
		},
		startTimer() {
			// Set up a repeating timer using setInterval
			this.timer = setInterval(() => {
				this.timerRemaining = this.formatTime(this.timeLeftInSeconds); // Format the time remaining in a human-readable format and store it in 'this.timerRemaining'

				// If there is time remaining, decrement the 'timeLeftInSeconds' by 1 second
				if (this.timeLeftInSeconds > 0) {
					this.timeLeftInSeconds--;
				} else {
					this.stopRec(); // If the time is up (timeLeftInSeconds reaches 0), stop the recording using 'this.stopRec()'
					this.timeLeftInSeconds = 0;
				}
			}, 1000); // Repeat the timer every 1000 milliseconds (1 second)
		},
		async stopRec() {
			this.isSubmitted = true;

			this.record = false; // Enable the start button again after stopping the recording
			this.videoSaved = true;

			this.stopTimer(); // Stop the timer for recording duration

			await this.$nextTick(); // Wait for playback video element to be mounted

			// Stop the video recording using the 'stopRecording' method of the 'recorder' instance
			// Pass the 'stopRecordingCallback' function as a callback to handle the result
			await this.flushFinalChunk();
			this.stopVideoStream();
			setTimeout(() => {
				const playbackVideo = this.$refs.playbackVideo;
				if (playbackVideo) {
					playbackVideo.muted = false;
					playbackVideo.volume = 1;
				}
			}, 100);
			// this.stopRecordingCallback();
		},
		stopTimer() {
			//Calculating the exact time in seconds for the recorded video
			this.actualRecordedDuration = 120 - this.timeLeftInSeconds;
			this.timeInSeconds = this.actualRecordedDuration;

			clearInterval(this.timer); // Clear the interval to stop the countdown timer
			this.timeLeftInSeconds = 120; // Reset the 'timeLeftInSeconds' to a default value (10 seconds in this case)
			this.timerRemaining = "02:00";
		},

		captureCamera(callback) {
			console.log("Requesting camera access...");
			navigator.mediaDevices
				.getUserMedia({
					audio: { echoCancellation: true },
					video: true,
				})
				.then((camera) => {
					console.log("Camera access granted:", camera);
					callback(camera);
				})
				.catch((error) => {
					console.error("Camera access error:", error);
					this.errorModal(
						"Permission Error",
						"Please check your browser settings to allow access to your camera."
					);
				});
		},
		retakeRec() {
			window.location.reload();
		},
		async bcktosyscheck() {
			await this.stopVideoStream();
			if (this.recorder && this.recorder.state === "recording") {
				this.stopRec();
			}
			this.$router.push({
				name: "systemcheck",
			});
		},
		gobcktoPreview() {
			if (!this.previewState) {
				this.$store.commit("candidateVUEX/updatePreviewResume", true);
			}
			const mobile = window.innerWidth < 1024;
			if (mobile) {
				this.$router.push({
					name: "MobilePreviewResume",
					query: { snapshot: true },
				});
			} else {
				this.$router.push({
					name: "CandidateDashboard",
				});
			}
		},
		async saveVideo() {
			try {
				try {
					const res = await finishUpload(this.uploadData._id, {
						convert: {
							delimiterKey: "videoResume",
						},
					});
					if (res.status == 200) {
						this.videoRecorder?.stop();
						this.showProgressBar = true;
						this.startProgressInterval();
						this.postVideoResume();
					}
				} catch (error) {
					console.error("Error completing upload:", error);
				}
			} catch (error) {
				clearInterval(this.progressInterval);
				console.log(error.message);
				this.showProgressBar = false;
				this.errorModal("Error", "Something went wrong");
			}
		},
		async postVideoResume() {
			try {
				var fileName = `${this.candidateInfoState._id}_videoResume.mp4`;
				var payload = {
					email: this.email,
					videoResumePath: `CandidateInfo/dev/${this.candidateInfoState.email}/${this.candidateInfoState._id}/videoResume/${this.timestamp}/${fileName}`,
				};
				const res = await postVideoResume(payload);
				if (res.status === 200) {
					this.progress = 100;
					this.uploaded = true;
				}
			} catch (error) {
				clearInterval(this.progressInterval);
				console.log(error.message);
				this.showProgressBar = false;
				this.errorModal("Error", "Something went wrong");
			}
			// clearInterval(this.progressInterval);
		},
		startProgressInterval() {
			const minimumDuration = 2000;
			const startTime = Date.now();

			this.progress = 0;
			this.progressInterval = setInterval(async () => {
				const elapsedTime = Date.now() - startTime;

				if (elapsedTime < minimumDuration) {
					this.progress = (elapsedTime / minimumDuration) * 100;
				} else if (this.uploaded) {
					this.progress = 100;
					clearInterval(this.progressInterval);
					this.showProgressBar = false;
					this.stopVideoStream();
					this.gobcktoPreview();
				} else {
					this.progress = 95;
				}

				this.progressPercentage = Math.floor(this.progress);
				this.updateProgressBarBackground();
			}, 50);
		},
		updateProgressBarBackground() {
			const containerss = this.$refs.progressContainer;
			const percentage = this.progressPercentage / 100;
			const rotation = percentage * 360;
			containerss.style.background = `conic-gradient(white ${rotation}deg, transparent ${rotation}deg)`;
		},
		stopVideoStream() {
			const stopTracks = (stream) => {
				if (stream) {
					stream.getTracks().forEach((track) => {
						if (track.readyState === "live") {
							try {
								track.stop();
								console.log("Track stopped:", track);
							} catch (error) {
								console.error("Error stopping track:", error);
							}
						}
					});
				}
			};

			// Stop both local and stored streams
			stopTracks(window.localVideoStream);
			stopTracks(this.videoStream);

			// Clear references
			window.localVideoStream = null;
			this.videoStream = null;

			// Clear video element source
			if (this.$refs.recordingVideo) {
				this.$refs.recordingVideo.srcObject = null;
			}
			if (this.$refs.camera) {
				this.$refs.camera.srcObject = null;
			}

			console.log("Video stream stopped successfully.");
		},
		getSupportedMimeType() {
			const types = [
				"video/mp4",
				"video/webm;codecs=h264",
				"video/webm",
				"video/ogg",
			];
			for (const type of types) {
				if (MediaRecorder.isTypeSupported(type)) {
					console.log("Using MIME type:", type);
					return type;
				}
			}
			console.warn("No supported MIME type found, letting browser decide.");
			return "";
		},
	},
};
</script>
<style>
.mob-vid-loader {
	position: absolute;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
	backdrop-filter: blur(3px);
}
.flipped-video-container {
	position: relative;
}

.flipped-video {
	width: 100%;
	height: 100%;
	transform: scaleX(-1);
}

/* Adjust media controls position */
.flipped-video::-webkit-media-controls {
	transform: scaleX(-1);
}

.flipped-video::-webkit-media-controls-fullscreen-button {
	display: none;
}

/* Hide all native controls */
video::-webkit-media-controls {
	display: none !important;
}

video::-webkit-media-controls-enclosure {
	display: none !important;
}

video::-webkit-media-controls-panel {
	display: none !important;
}

video::-webkit-media-controls-start-playback-button {
	display: none !important;
}
</style>
